<div class="swv">
  <div class="swv-cargando" *ngIf="cargando">Descargando la especificación…</div>
  <div class="swv-error" *ngIf="!cargando && error">{{ error }}</div>
  <div class="swv-error" *ngIf="!cargando && !error && errorVisor">{{ errorVisor }}</div>
  <div class="swv-cargando" *ngIf="!cargando && !error && !errorVisor && renderizando">Cargando el visor…</div>
  <p class="swv-ayuda" *ngIf="!cargando && !error && yaml">
    Sólo lectura: la API se firma con tu clave privada, así que no se puede probar desde el navegador. Usá la colección Postman.
  </p>
  <div class="swv-nodo" #nodo [hidden]="cargando || !!error"></div>
</div>
